module.exports = __webpack_public_path__ + "img/naborisk.5b484089.png";